import React, { useEffect, useState } from "react";
import { Form, Icon, Input, List, Button, Alert } from "antd";
import { Link, withRouter } from "react-router-dom";
import { api } from "../../http.request";
import { Session, User_Preferences, Utilitaries } from "../../../business";
import { getuserComputerInfo, queryToString } from "../../util";
import { IS_UNICV, DEV_UNICV } from "../../../constants/enviroment";

const LoginForm = (props) => {
    const [error, setError] = useState(null);
    const [listLogin, setListLogin] = useState([]);
    const [loading, setLoading] = useState(false);

    const search = props.location.search;
    const params = new URLSearchParams(search);
    const tmp_login_identifier = params.get("autenticacao_temp");
    const tmp_login_password = params.get("chave_temp");

    const userInfo = getuserComputerInfo();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleLogin = async (username, password, is_tmp_login = false) => {
        Session.remove();
        Session.unlockScreen();

        setLoading(true);
        setListLogin([]);
        const formData = new FormData();

        formData.append("accao", DEV_UNICV ? "login-teste" : "login-json");
        formData.append("utilizador", username);
        formData.append("senha", password);
        formData.append("os", userInfo.plataform);
        formData.append("browser", userInfo.browser);
        formData.append("computer", userInfo.computer_uuid);

        if (is_tmp_login) {
            formData.append("tipo_auth", "autenticacao_temp");
        }

        try {
            const resp = await api("/Gestor/gereutilizador.php", formData);

            if (resp.erro) {
                setError(resp.erro);

                if (resp.list) {
                    setListLogin(resp.list);
                }
            } else {
                Session.save({
                    username: resp.username,
                    name: resp.nome,
                    token: resp.token,
                    type: resp.tipo,
                    photoURL: resp.foto_unicv,
                    isFirstLogin: resp.isFirstLogin,
                    parametro1: resp.parametro1,
                    parametro2: resp.parametro2,
                    parametro3: resp.parametro3,
                });

                User_Preferences.addTimeToLookScreen(resp.time_to_look_screen || 300000);

                return {
                    success: true,
                    action: resp.accao_automatica,
                };
            }
        } catch (error) {
            console.error(error);
            setError(error.erro);

            if (error.list) {
                setListLogin(error.list);
            }
        }
    }

    const handleIniciarProcessoAutomatico = async (username, password) => {
        const formData = new FormData();
        formData.append("accao", "processo_automatico");

        try {
            const resp = await api("/Gestor/gereprocesso.php", formData);

            if (resp.erro) {
                setError(resp.erro);
            } else {
                console.log("processo automático iniciado", { resp });
                return resp;
            }
        } catch (error) {
            console.error(error);
            setError(error.erro);
        }
    }

    useEffect(() => {
        console.log("entrou");
        if (!Utilitaries.isEmpty(tmp_login_identifier) && !Utilitaries.isEmpty(tmp_login_password)) {
            console.log("entrou", { tmp_login_identifier, tmp_login_password });
            handleLogin(tmp_login_identifier, tmp_login_password, true)
                .then((resp) => {
                    if (resp && resp.success && resp.action === "INICIA_PROCESSO") {
                        // iniciar processo
                        console.log("iniciar processo");
                        return handleIniciarProcessoAutomatico();
                    } else {
                        console.log("não iniciar processo", { resp });
                    }
                })
                .then((result) => {
                    console.log("processo automático resultado", { result });
                    const data = result.dados
                    const url = `/task/execution/map/${data.processo["@id"]}?taskId=${data.tarefa["@id"]}&routeContext=panel&pageAction=panel&processParentId=&forceView=execution`;
                    window.location.hash = url;
                    window.location.reload();
                })
                .catch((error) => {
                    Session.remove();
                    Session.unlockScreen();
                })
                .finally(() => {
                    setLoading(false);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tmp_login_identifier, tmp_login_password]);

    function handleSubmit(e) {
        e.preventDefault();
        setError(null);
        props.form.validateFields(async (err, values) => {
            if (!err) {
                const resp = await handleLogin(values.username, values.password);
                setLoading(false);
                if (resp && resp.success) {
                    const query = queryToString();

                    if (query["redirect"]) {
                        const redirect = query["redirect"];
                        if (redirect.startsWith("/login")) {
                            window.location.hash = "/";
                        } else {
                            window.location.hash = redirect || "/";
                        }
                        window.location.reload();
                    } else {
                        window.location.reload();
                    }
                }
            }
        });
    }

    const logout = async (id) => {
        const formData = new FormData();
        formData.append("accao", "logout");
        formData.append("id", id);

        try {
            const resp = await api("/Gestor/gereutilizador.php", formData);
            if (!resp.erro) {
                setListLogin(listLogin.filter((it) => it.id !== id));
            }
        } catch (error) {}
    }

    const { getFieldDecorator } = props.form;

    return (
        <div className="login-body">
            <div style={{ width: "300px", marginTop: "20px" }}>
                {error && <Alert message={error} type="error" banner />}
            </div>

            {listLogin.length > 0 && (
                <List
                    header={<div>Logins ativos ({listLogin.length})</div>}
                    dataSource={listLogin}
                    renderItem={(item) => (
                        <List.Item key={item.id}>
                            <List.Item.Meta description={item.os + " - " + item.browser} />
                            <div>
                                <Button type="link" onClick={() => logout(item.id)}>
                                    Logout
                                </Button>
                            </div>
                        </List.Item>
                    )}
                ></List>
            )}

            {Utilitaries.isEmpty(tmp_login_identifier) && Utilitaries.isEmpty(tmp_login_password) && (
                <Form onSubmit={handleSubmit} className="login-form">
                    <Form.Item>
                        {getFieldDecorator("username", {
                            rules: [
                                {
                                    required: true,
                                    message: "Informe o E-mail!",
                                },
                            ],
                            initialValue: Session.getLastLoginUsername(),
                        })(
                            <Input
                                disabled={loading}
                                prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
                                placeholder="Utilizador"
                            />
                        )}
                    </Form.Item>
                    <Form.Item>
                        {getFieldDecorator("password", {
                            rules: [
                                {
                                    required: true,
                                    message: "Informe a senha!",
                                },
                            ],
                        })(
                            <Input.Password
                                disabled={loading}
                                prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
                                placeholder="Senha"
                            />
                        )}
                    </Form.Item>
                    <Form.Item>
                        <Link className="login-form-forgot" to="/request-reset-password">
                            Esqueci-me da senha!
                        </Link>
                        <Button loading={loading} type="primary" htmlType="submit" className="login-form-button">
                            Login
                        </Button>

                        {IS_UNICV && (
                            <Link to="/register/unicv" style={{ marginTop: 10 }}>
                                <Button type="link" block style={{ marginTop: 10 }}>
                                    Criar conta
                                </Button>
                            </Link>
                        )}
                    </Form.Item>
                </Form>
            )}
        </div>
    );
};

export default withRouter(Form.create({ name: "normal_login" })(LoginForm));
